import { render, staticRenderFns } from "./CompanyAdd.vue?vue&type=template&id=2cf80cfc&"
import script from "./CompanyAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAdd.vue?vue&type=style&index=0&id=2cf80cfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports